import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { CompactCard } from '../../components';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import { HROtherRequestsRequest } from '../../requests/dashboards';
import OtherRequestDataTable from '../Shared/OtherRequest/OtherRequestDataTable';
import columns from '../Shared/OtherRequest/approveColumns';

const OtherRequestIndex = ({ moreData, setMoreData, todayMoment = null, twoMonthsAgo = null }) => {
  const [activeCard, setActiveCard] = useState('all');
  const [cards, setCards] = useState({});
  const [customParams, setCustomParams] = useState({});
  const [defaultStartDate, setDefaultStartDate] = useState(twoMonthsAgo);
  const [defaultEndDate, setDefaultEndDate] = useState(todayMoment);
  const [nameRangePicker, setNameRangePicker] = useState('');
  const dispatch = useDispatch();

  const fetchDashboardCards = () => {
    const request = async () => {
      HROtherRequestsRequest({
        dispatch,
        successCallback: response => setCards(camelCaseEmptyStringRecursive(response.data))
      });
    };
    request();
  };

  const handleClick = card => {
    switch (card) {
      case 'pending':
        setCustomParams({ status: 'pending' });
        setNameRangePicker('date_range');
        setActiveCard('pending');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
      case 'approved':
        setCustomParams({ status: 'approved' });
        setNameRangePicker('grant_date');
        setActiveCard('approved');
        setDefaultStartDate(moment().startOf('year'));
        setDefaultEndDate(moment().endOf('year'));
        setMoreData(!moreData);
        break;
      case 'rejected':
        setCustomParams({ status: 'rejected' });
        setNameRangePicker('date_range');
        setActiveCard('rejected');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
      default:
        setCustomParams({});
        setNameRangePicker('date_range');
        setActiveCard('all');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
    }
  };

  useEffect(fetchDashboardCards, [moreData]);

  return (
    <>
      <Row className="mt-3 mb-3">
        <Col md={3} xs={12}>
          <CompactCard
            variant="info-grey"
            title={cards.all}
            label="Solicitadas"
            subtitle="Solicitudes Solicitadas"
            active={activeCard === 'all'}
            onClick={() => handleClick('all')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="warning"
            title={cards.pending}
            label="Por Autorizar"
            subtitle="Solicitudes por autorizar"
            active={activeCard === 'pending'}
            onClick={() => handleClick('pending')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="danger"
            title={cards.rejected}
            label="Rechazadas"
            subtitle="Solicitudes Rechazadas"
            active={activeCard === 'rejected'}
            onClick={() => handleClick('rejected')}
          />
        </Col>
      </Row>
      <OtherRequestDataTable
        columns={columns}
        customParams={customParams}
        defaultStartDate={defaultStartDate}
        defaultEndDate={defaultEndDate}
        moreData={moreData}
        setMoreData={setMoreData}
        nameRangePicker={nameRangePicker}
      />
    </>
  );
};

export default OtherRequestIndex;
